module.exports = __webpack_public_path__ + "static/media/ic-chevron-selected.73081d74.svg";